import { render } from "./sys-role.vue?vue&type=template&id=1eaab4ac&scoped=true"
import script from "./sys-role.vue?vue&type=script&lang=js"
export * from "./sys-role.vue?vue&type=script&lang=js"

import "./sys-role.vue?vue&type=style&index=0&id=1eaab4ac&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eaab4ac"]])

export default __exports__